import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Typo from 'constants/typography'
import compose from 'recompose/compose'
import Icon from 'components/common/icon'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import style from './cart-diamond-deal-banner.scss'

const CartDiamondDealBanner = ({ t, dealInfo }) => (
  <React.Fragment>
    <style jsx>{style}</style>
    <div className="cart-diamond-deal-banner">
      <div className="cart-diamond-deal-banner__icon">
        <Icon src={ICONS.diamondWhite} size={ICON_SIZE.small} />
        <div className={Typo.caption}>
          {hasLocizeTranslation(t, 'DIAMOND_DEAL', 'Diamond Deal')}
        </div>
      </div>
      <div className="cart-diamond-deal-banner__content">
        <div className={Typo.caption}>{dealInfo}</div>
      </div>
    </div>
  </React.Fragment>
)

CartDiamondDealBanner.defaultProps = {
  dealInfo: '',
}

CartDiamondDealBanner.propTypes = {
  dealInfo: PropTypes.string,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    internationalization: state.internationalization,
  })),
  withI18next(),
)(CartDiamondDealBanner)
